import "./appeal-form.scss";

import { Grid, InputLabel, Select, TextareaAutosize, TextField, Typography } from "@mui/material";

interface Formfield {
  error?: boolean;
  label?: string;
  value?: string;
  fieldType?: string;
  title: string;
  name?: string;
  errorMessage?: any;
  handleChange?: any;
  handleBlur?: any;
  windowSize?: any;
  children?: React.ReactNode;
}

const FormField = (props: Formfield) => {
  const { error, label, value, name, fieldType, handleChange, handleBlur, errorMessage, children } = props;
  return (
    <Grid item={true} xs={12} lg={8}>
      <InputLabel htmlFor={name} className={error ? "label-err" : "label"}>
        {label} <span style={{ color: "red" }}>*</span>
      </InputLabel>

      {fieldType === "textField" ? (
        <TextField name={name} fullWidth size="small" variant="outlined" error={error} value={value} onChange={handleChange} onBlur={handleBlur} className={error ? "error-border" : ""} />
      ) : fieldType === "textArea" ? (
        <TextareaAutosize
          name={name}
          minRows={1}
          style={{
            fontFamily: `Roboto`,
          }}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`text-area ${error ? "error-border" : ""}`}
        />
      ) : fieldType === "select" ? (
        <Select
          sx={{ width: "100%" }}
          name={name}
          fullWidth
          size="small"
          variant="outlined"
          error={error}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          className={error ? "error-border" : ""}
        >
          {children}
        </Select>
      ) : (
        <>{children}</>
      )}
      {error && (
        <Typography className="error-color" variant="body2">
          {errorMessage}
        </Typography>
      )}
    </Grid>
  );
};

export default FormField;
